import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { loadScript } from '../lib/load-script';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class TenantGoogleAnalyticsService {
  private platformId = inject(PLATFORM_ID);
  private state = inject(StateService);
  loaded = false;

  public load(googleAnalyticsId: string): void {
    if (isPlatformServer(this.platformId)) return;
    const email = this.state.user?.email;
    if (email && ['@nusign.com', '@picflow.com'].find(_email => email.endsWith(_email))) return;
    if (this.state.impersonating) return;

    if (this.loaded) return;
    this.loaded = true;
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      // eslint-disable-next-line prefer-rest-params , @typescript-eslint/no-explicit-any
      (window.dataLayer as any).push(arguments);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (gtag as any)('consent', 'default', {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted',
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (gtag as any)('js', new Date());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (gtag as any)('config', googleAnalyticsId);

    loadScript(`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`);
  }
}
